import React, {useEffect, useState} from "react"
import { getAllQty, getStock } from "../../../helpers/product";
import * as productsAPIUtil from "../../../util/products/productsAPIUtil"

export const useCheckoutFee = (props) => {
    const {cartItems, handlingFeeCalculation, addHandlingFeeAmt, generalShipFrom, isStock, validateInventory, isAllowoutofStockOrder} = props;
    const [moqErrors, setMoqErrors] = useState([])
    const [quantityErrors, setQuantityErrors] = useState([])
    const [stockErrors, setStockErrors] = useState([]);
    const [inventoryStock, setInventoryStock] = useState([])
    const [dtsInventoryStock, setDtsInventoryStock] = useState([])
    const [validateStock, setValidateStock] = useState(false);

    useEffect(() => {
        const moqRestriction = [];
        const quantityRestriction = []
        cartItems.forEach((cartItem, mainI) => {
            let product = cartItem.product;
            cartItem.currentOrder.forEach((item, itemI) => {
            item.forEach((skuItem, variationI) => {
                let color = skuItem.color;
                let size = skuItem.size;
                let quantity = skuItem.quantity;
                const partPrice = product.WebstoreProductPartArray[0]?.partPrice?.PartPriceArray?.PartPrice ??
                    product?.ProductPartArray?.ProductPart?.[0]?.partPrice?.PartPriceArray?.PartPrice 
                const isPrintable = !!product.isPrintable
                if (product.isProductskuMoq || product.isProductMoq) {
                  if(product.isProductskuMoq) {
                      color = null;
                      size = null;
                  }
                  if(partPrice) {
                      const productMinQuantity = minQuantity(partPrice);
                      let totalQuantity = getCartItemSizeTotalByProduct(product.productId, mainI, itemI, quantity, variationI, color, size)
                      if (totalQuantity < productMinQuantity) {
                        let message = `Minimum quantity should be ${productMinQuantity} on product ${product.productName} ${color && size ? `on color: ${color} and size: ${size}` : ''}`;
                        if(moqRestriction.findIndex(x => x === message) === -1){
                          moqRestriction.push(message);
                        }
                        return false;
                      }
                  }
                }
                if(product.isRestrictQty) {
                  if(product.isProductskuMoq) {
                    color = null;
                    size = null;
                  }
                  if(partPrice) {
                    const productAllQuantity = getAllQty(partPrice);
                    let totalQuantity = isPrintable || product?.doNotCalculateAtOrder == "1" ? Number(quantity) : getCartItemSizeTotalByProduct(product.productId, mainI, itemI, quantity, variationI, color, size)
                    let minQTy = productAllQuantity
                    if(productAllQuantity.length > 1) {
                      minQTy = productAllQuantity.join(', ')
                    }
                    if (!productAllQuantity.includes(totalQuantity)) {
                      let message = `Minimum quantity should be ${minQTy.toString()} on product ${product.productName} ${color && size ? `on color: ${color} and size: ${size}` : ''}`;
                      if(quantityRestriction.findIndex(x => x === message) === -1)
                        quantityRestriction.push(message);
                      return false;
                    }
                  }
                }
              }) 
            })
        })
        setQuantityErrors(quantityRestriction)
        setMoqErrors(moqRestriction);
    }, [cartItems])

    useEffect(() => {
      if((dtsInventoryStock.length > 0 || inventoryStock.length > 0) && isStock && validateInventory) {
        const stockRestriction = [];
        cartItems.forEach(cartItem => {
          const itemProductId = cartItem.product?.productId
          const productId = cartItem.product?.id
          const isStockFor = !!!cartItem.product?.isStockFor || cartItem.product.isStockFor === 'globalsetting' ? isStock : cartItem.product.isStockFor
          let dtsInventoryProduct = [];
          dtsInventoryStock.forEach(dtsInventoryArray => {
            dtsInventoryArray.forEach(dtsInventory => {
              if(dtsInventory.productId === cartItem?.product?.productId) {
                dtsInventoryProduct.push(dtsInventory);
              }
            })
          })
          const IsAllowOutofStock = typeof cartItem.product.AllowOutofStock === 'boolean' ? cartItem.product.AllowOutofStock : isAllowoutofStockOrder
          if(IsAllowOutofStock === false) {
            cartItem.currentOrder.forEach(item => {
              item.forEach(skuItem => {
                let color = skuItem.color;
                let size = skuItem.size;
                let quantity = Number(skuItem.quantity);
                const stockData = getStock(size, color,
                  inventoryStock.find(x => productId === x.id?.toString()) || {},
                  cartItem?.product,
                  dtsInventoryProduct,
                  isStockFor);
                const quantityInCart = getOthersQuantity(size, color, itemProductId, quantity);
                if(quantity > (stockData - quantityInCart)) {
                  let productStock = { ...skuItem, stockData: stockData, productId: itemProductId }
                  stockRestriction.push(productStock)
                }
              }) 
            })
          }
        })
        setStockErrors(stockRestriction)
      }
  }, [cartItems, isStock, validateInventory, validateStock])

    useEffect(() => {
      if(cartItems?.length && !!isStock && (dtsInventoryStock.length === 0 || inventoryStock.length === 0)) {
        fetchData()
      }
    }, [cartItems, isStock])

    const fetchData = async ()=>{
      let promises = []
      let products = []
      cartItems.map(async (item)=>{
        const IsAllowoutofStockOrder = typeof item.product.AllowOutofStock === 'boolean' ? item.product.AllowOutofStock : isAllowoutofStockOrder
        if(products.findIndex(x => x === item.product.id) === -1 && IsAllowoutofStockOrder === false) {
          promises.push(productsAPIUtil.getProductStock(item.product.id));
          products.push(item.product.id)
        }
      })
      let inventoryArrayDatatemp = [];
      let dstInventoryArrayDataTemp = [];
      let productInventoryArray = []
      if(promises.length > 0) {
        await Promise.all(promises)
          .then((data)=>{
            if ( data && data.length > 0 ) {
              data.map((res)=>{
                if ( res && res.data ) {
                  /*
                  Product inventory
                  */
                  let productInventory = res.data.inventory
                  productInventoryArray.push(productInventory)
                  let productItem = cartItems.filter(
                      (itemFilter)=>
                          itemFilter.product.productId ===
                          productInventory.productId,
                  )[0]
                  if ( productInventory && productItem?.product ) {
                    if (
                        productInventory.productId ===
                        productItem.product.productId
                    ) {
                      inventoryArrayDatatemp[productItem.product.productId] =
                          productInventory.PartInventoryArray?.PartInventory
                    }
                  }
                  // dstInventory
                  if (res.data.dtsInventory?.data?.length) {
                    dstInventoryArrayDataTemp.push(res.data.dtsInventory?.data)
                  }
                }
              })
              setInventoryStock(productInventoryArray)
              setDtsInventoryStock(dstInventoryArrayDataTemp)
            }
  
          })
          .catch((error)=>{
            console.log('error', error)
          }).finally(() => setValidateStock(true))
      }
    }

    const getHandlingFee = (amount) => {
        if(!handlingFeeCalculation) {
            return 0
        }
        let amt = 0
        let totalQty = 0
        !!cartItems && cartItems.length > 0 && cartItems.forEach((cartItem) => {
            cartItem.currentOrder.forEach((order) => {
                order.map((orderRow) => {
                    totalQty = Number(totalQty) + Number(orderRow.quantity)
                })
            })
        })
        if (handlingFeeCalculation === 'FlatRatePerOrder') {
            amt = Number(addHandlingFeeAmt)
        }
        else if (handlingFeeCalculation === 'FlatRatePerItem') {
            amt = totalQty * Number(addHandlingFeeAmt)
        } else if (handlingFeeCalculation === 'PercentageofOrder') {
            amt = (Number(amount) * Number(addHandlingFeeAmt)) / 100
        }
      return amt
    }

    const getCartItemSizeTotalByProduct = (productId, rowKey, itemKey, newValue, variationIndex, color = null, size = null) => {
        let total = 0
        if (cartItems && cartItems.length > 0) {
          cartItems.forEach((caItems, mainRowIndex) => {
            if (caItems?.product?.productId === productId) {
              return caItems?.currentOrder.forEach((sku, itemIndex) => {
                return sku?.forEach((skuItem, index) => {
                  if((color === null && size === null) || (color === skuItem.color && size === skuItem.size)) {
                    if (index === variationIndex && mainRowIndex === rowKey && itemIndex === itemKey) {
                      total += Number(newValue);
                    } else {
                      total += Number(skuItem.quantity)
                    }
                  }
                })
              })
            }
          })
        }
        return total
    }

    const minQuantity = (partPrice) => {
        let minObj = partPrice.reduce(function (prev, curr) {
          return Number(prev.minQuantity) < Number(curr.minQuantity) ? prev : curr
        })
        return Number(minObj.minQuantity);
    }

    const getQuantityProduct = (currentOrder) => {
      let quantity = 0;
      if(currentOrder) {
        currentOrder.forEach(row => {
          row.forEach(unit => {
            quantity += Number(unit.quantity)
          })
        })
      }
      return quantity
    }

    const addLineItems = (arrayShipStation, product=null) => {
      const lines = []
      if (!!product) {
        let postalCode = product.shipFromPostalCode ?? generalShipFrom.shipFromPostalCode;
        let index = lines.findIndex(x => x.postalCode === postalCode);
        if (index === -1) {
          lines.push({ postalCode: postalCode, lines: 1 })
        } else {
          lines[index].lines += 1
        }
      } else {
        cartItems.forEach(item => {
          item.currentOrder.forEach(listProducts => {
            let postalCode = item.product.shipFromPostalCode ?? generalShipFrom.shipFromPostalCode;
            let index = lines.findIndex(x => x.postalCode === postalCode);
            if (index === -1) {
              lines.push({ postalCode: postalCode, lines: 1 })
            } else {
              lines[index].lines += 1
            }
          });
        });
      }
      arrayShipStation.forEach(x => {
        let index = lines?.findIndex(y => y.postalCode === x.fromPostalCode);
        x.lines = lines?.[index]?.lines;
      })
      return arrayShipStation;
    }

    const getOthersQuantity = (size, color, productId, quantity) => {
      let quantityInCart = 0;
      cartItems.forEach((cardProduct, x) => {
        if(cardProduct.product.productId === productId) {
          cardProduct.currentOrder.forEach((currentOrder, y) => {
            currentOrder.forEach((product, z) => {
              if(product.size === size && product.color === color) {
                quantityInCart += Number(product.quantity);
              }
            })
          })
        }
      })
      return quantityInCart - quantity;
    }

    return {
        getHandlingFee,
        moqErrors,
        getCartItemSizeTotalByProduct,
        minQuantity,
        quantityErrors,
        getQuantityProduct,
        addLineItems,
        getOthersQuantity,
        stockErrors,
        validateStock,
    }
}
